import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { dateToDisplay } from '../../../../../common/helpers';
import FilterPill from '../filterpill/FilterPill';

const DateFilterPill = (props) => {
    const renderValue = useCallback(() => {
        if (props.filterDefinition.singleDay) return `${dateToDisplay(props.filter.value.from)}`;

        if (props.filter.value.today) return 'Today';

        if (props.filter.value.from && props.filter.value.to) {
            return `${dateToDisplay(props.filter.value.from)} - ${dateToDisplay(props.filter.value.to)}`;
        }

        if (props.filter.value.from) return `${dateToDisplay(props.filter.value.from)} and later`;

        if (props.filter.value.to) return `up to ${dateToDisplay(props.filter.value.to)}`;

        return 'All';
    }, [props.filterDefinition, props.filter]);

    return (
        <FilterPill
            fixed={ props.fixed }
            disabled={ props.disabled }
            filter={ props.filter }
            filterError={ props.filterError }
            displayValue={ renderValue() }
            isOpen={ props.isOpen }
            openFilter={ props.openFilter }
            removeFilter={ props.removeFilter }
            updateFilter={ props.updateFilter }
            filterDefinition={ props.filterDefinition }
        />
    );
};

DateFilterPill.propTypes = {
    filterDefinition: PropTypes.shape({
        singleDay: PropTypes.bool
    }),
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.shape({
            to: PropTypes.string,
            from: PropTypes.string,
            today: PropTypes.bool
        })
    }),
    filterError: PropTypes.shape({}),
    isOpen: PropTypes.bool,
    openFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired
};

DateFilterPill.defaultProps = {
    filterDefinition: null,
    fixed: false,
    filter: {
        value: {
            to: null,
            from: null,
            today: false
        }
    },
    filterError: null,
    disabled: false,
    isOpen: false
};

export default DateFilterPill;
